import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ErrorVTO, LookupZonesResultSet } from '../../pages/admin-dashboard/products/product.model';
import { AuthService } from '../auth-service';
import { LookupResultSet } from '../../pages/admin-dashboard/admin-companies/admin-companies.model';

@Injectable({ providedIn: 'root' })
export class ProductsLookupService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.productsApiUrl;

  getLookupVolumeUnits() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupResultSet>(`${this.API}/lookup/units/volumes`, { headers }).pipe(
      tap(() => console.log('Lookup volume units retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getLookupConcentrationUnits() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupResultSet>(`${this.API}/lookup/units/concentrations`, { headers }).pipe(
      tap(() => console.log('Lookup concentration units retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getLookupForms() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupResultSet>(`${this.API}/lookup/forms`, { headers }).pipe(
      tap(() => console.log('Lookup forms retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getLookupMFGCompanies() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupResultSet>(`${this.API}/lookup/companies/mfg`, { headers }).pipe(
      tap(() => console.log('Lookup MFG companies retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getLookupCategories() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupResultSet>(`${this.API}/lookup/categories`, { headers }).pipe(
      tap(() => console.log('Lookup categories retrieved successfully')),
      catchError(this.handleError),
    );
  }
  getLookupSubCategories(categoryId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);

    return this.http
      .get<LookupResultSet>(`${this.API}/lookup/subcategories`, {
        headers,
        params: { categoryId: categoryId.toString() },
      })
      .pipe(catchError(this.handleError));
  }

  getLookupZones(): Observable<LookupZonesResultSet> {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<LookupZonesResultSet>(`${this.API}/lookup/zones`, { headers }).pipe(
      tap(() => console.log('Lookup zones retrieved successfully')),
      catchError(this.handleError),
    );
  }
  private handleError(error: HttpErrorResponse) {
    const apiError: ErrorVTO = error.error;
    console.error('An API error occurred:', apiError);
    return throwError(() => apiError);
  }
}
